/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Variant_DuplicateInputs */

const vi_error_shop_variant_duplicate = /** @type {(inputs: Error_Shop_Variant_DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SKU này đã có trong nhóm.`)
};

/**

* @param {Error_Shop_Variant_DuplicateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_variant_duplicate = /** @type {((inputs?: Error_Shop_Variant_DuplicateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Variant_DuplicateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_variant_duplicate(inputs)
});